<template>

    <div v-if="getPermission.settings.view || getPermission.stcMgt.view || getPermission.acnit.view || getPermission.stcAcct.view || getPermission.stcWithPM.view || getPermission.stcAuditOnly.view || getPermission.stcfsireadonlyforerlmgt.view">  




    <md-card class="searchPanel">
      <md-card-content>
        <div class="md-layout md-gutter">
          <div  v-if="active" class="md-layout-item md-size-20 ">
            <div class = "inputBox">
              <md-field>
                <label>Price Agreement</label>
                <md-input v-model="searchRequest.agreement"/>
              </md-field>
            </div>
            <div class = "inputBox">
              <md-field>
                <label>Rate Type</label>
                <md-input v-model="searchRequest.rateType"/>
              </md-field>
            </div>
          </div>


          <div v-if="active" class="md-layout-item md-size-20 ">
             <div class = "inputBox">
               <datepicker v-model="searchRequest.validOn" >
                <label>Valid On</label>
              </datepicker>
            </div>
            <div class = "inputBox">
              <auto-complete-master-data-select
                          label="Sales Office"
                          display-type="idOnly"
                          :prepared-options="this.getMasterDataAsSelectOptionByGroup('GST_SALEOFFICE')"
                          :init-value-id="searchRequest.salesOffice"
                          :on-item-changed="handleOfficeChanged">
              </auto-complete-master-data-select>
            </div>
          </div>


          

          <div v-if="active" class="md-layout-item md-size-20 ">
            <div class = "inputBox">
              <md-field>
                <label>Payer</label>
                <md-input v-model="searchRequest.payer"/>
              </md-field>
            </div>
          </div>


          <div v-if="active" class="md-layout-item md-size-20">
                <div class = "inputBox">
              <md-field>
                <label>Depature Point</label>
                <md-input v-model="searchRequest.departureCode" />
              </md-field>
            </div>
            <div class = "inputBox">
              <md-field>
                <label>Destination Point</label>
                <md-input v-model="searchRequest.destinationCode" />
              </md-field>
            </div>
          </div>


          <!--<div v-if="getPermission.ccic.edit" class="md-layout-item md-size-100 md-small-size-100">-->

          <div v-if="getPermission.stcMgt.edit || getPermission.acnit.edit || getPermission.stcAcct.view || getPermission.stcWithPM.edit || getPermission.stcAuditOnly.view || getPermission.stcfsireadonlyforerlmgt.view" class="md-layout-item md-size-100 md-small-size-100">  
            <callingApiCenter :paths="['/api/w/gst/gstpriceagreement/search']">
              <callingApiCenter path=" /api/w/gst/gstpriceagreement/search" :not-display-error="true">
                  <md-button v-if="this.getPermission.stcMgt.edit || this.getPermission.acnit.edit || getPermission.stcWithPM.edit" class="md-raised custButton " :disabled="getPermission.stcAuditOnly.view" @click="doNew" ><span class="icons-center material-icons">create</span>New</md-button>
                  <md-button v-if="this.getPermission.stcMgt.edit || this.getPermission.acnit.edit || getPermission.stcWithPM.edit" class="md-raised custButton " :disabled="!canEdit || getPermission.stcAuditOnly.view" @click="doCopy" ><span class="icons-center material-icons">create</span>Copy</md-button>
                  <md-button v-if="this.getPermission.stcMgt.edit || this.getPermission.acnit.edit || getPermission.stcWithPM.edit" class="md-raised custButton " :disabled="!canEdit || getPermission.stcAuditOnly.view" @click="doEdit" ><span class="icons-center material-icons">create</span>Edit</md-button>
                  <md-button id = "searchTag"  @click="doSearch" class=" custButton btn-search-special-form-stages md-primary md-raised">Search</md-button>
                  <md-button   class="md-raised custButton" @click="doClear">Clear</md-button>
             <input class = "custSearchBar" type="text"
                    placeholder="Searching Term"
                    v-model="filter"
                    />
            <md-button class="md-icon-button custButtonRight" @click="mouseLeave" id="expand-button">
              <md-icon v-if="active == false">keyboard_arrow_down</md-icon>
              <md-icon v-if="active == true">keyboard_arrow_up</md-icon>
            </md-button>
              </callingApiCenter>
            </callingApiCenter>
          </div>
        </div>
      </md-card-content>
    </md-card>

        <pagination :items="filteredRows">
      <template slot-scope="{pageItems}">
        <md-card class="data-table-container">
          <div class="outer-container">
            <div class="inner-container">
              <div class="table-header">
                <table id="headertable">
                  <thead>
                  <tr>
                    <th class="header-cell w2"></th>
                  </tr>

                  <th class="header-cell w2"  v-if="getPermission.stcMgt.edit || getPermission.acnit.edit || getPermission.stcWithPM.edit"></th>

                    <th class="header-cell center w5" v-on:click="sortFunction('agreement')">Price Agreement</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('adesc')">Desc</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('allInRate')">All in Rate</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('rateType')">Rate Type</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('rdesc')">Rate Desc</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('unit')">Price Unit</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('amt')">Amount</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('currency')">Currency</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('validFrom')">Valid From</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('validTo')">Valid To</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('salesOffice')">Sales Office</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('payer')">Payer</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('orderType')">Order Type</th>
                    <th class="header-cell center w10" v-on:click="sortFunction('departureCode')">Departure Point</th>
                    <th class="header-cell center w10" v-on:click="sortFunction('destinationCode')">Destination Point</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('commodity')">Commodity</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('ctnType')">CTN Type</th>
                    <th class="header-cell center w5" v-on:click="sortFunction('freeDay')">Chassis Free Days</th>
                    <th class="header-cell center w5" >Created</th>
                    <th class="header-cell center w5" >Created Date</th>
                    <th class="header-cell center w5" >Update</th>
                    <th class="header-cell center w5" >Update Date</th>

                
                  </thead>
                </table>
              </div>
              <div class="table-body " @scroll="handleScroll">
                <table id="bodytable">
                  <tbody>
                    <tr :key="item.vueKey" v-for="item in pageItems" 
                          v-bind:class ="{ selected: item.selected }">

                     <td class="body-cell w2 " v-if="getPermission.stcMgt.edit || getPermission.acnit.edit || getPermission.stcWithPM.edit">

                      <md-checkbox v-model="item.selected">
                        <!-- <span v-if="hasBeenChanged(item)">*</span> -->
                      </md-checkbox>
                    </td>
                    <td class="body-cell excelBox w5">{{item.agreement}}</td>
                    <td class="body-cell excelBox w5">{{item.adesc}}</td>
                    <td class="body-cell excelBox w5">{{item.allInRate}}</td>
                    <td class="body-cell excelBox w5">{{item.rateType}}</td>
                    <td class="body-cell excelBox w5">{{item.rdesc}}</td>
                    <td class="body-cell excelBox w5">{{item.unit}}</td>
                    <td class="body-cell excelBox w5">{{item.amt}}</td>
                    <td class="body-cell excelBox w5">{{item.currency}}</td>
                    <td class="body-cell excelBox w5">{{item.validFrom | date}}</td>
                    <td class="body-cell excelBox w5">{{item.validTo | date }}</td>
                    <td class="body-cell excelBox w5">{{item.salesOffice}}</td>
                    <td class="body-cell excelBox w5">{{item.payer}}</td>
                    <td class="body-cell excelBox w5">{{item.orderType}}</td>
                    <td class="body-cell excelBox w10">
                       <master-data-display group="GST_LOCATION" :tag-id="item.departureCode"/>
                     </td>
                    <td class="body-cell excelBox w10">
                       <master-data-display group="GST_LOCATION" :tag-id="item.destinationCode"/>
                     </td>
                    <td class="body-cell excelBox w5">{{item.commodity}}</td>
                    <td class="body-cell excelBox w5">{{item.ctnType}}</td>
                    <td class="body-cell excelBox w5">{{item.freeDay}}</td>
                    <td class="body-cell excelBox w5">{{item.createdBy}}</td>
                    <td class="body-cell excelBox w5">{{item.createdAt | date}}</td>
                    <td class="body-cell excelBox w5">{{item.updatedBy}}</td>
                    <td class="body-cell excelBox w5">{{item.updateAt | date}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </md-card>
      </template>
    </pagination>
    </div>





</template>


<style scoped>



.popup {
  position: relative;
  display: inline-block;
  cursor: pointer;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.spaceLine {
  margin-bottom: 10px;
}

.popuptext {
  visibility: show;
  width: 160px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 8px 0;
  position: absolute;
  z-index: 10;
  bottom: 125%;
  left: 50%;
  margin-left: -80px;
}

.excelBox {
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 5px;
    padding-right: 5px;
    text-align: center;
  
}

.excelBoxTB {
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 5px;
    padding-right: 5px;
    text-align: center;
    margin-right: 5px;
  
}

.excelBoxLeft {
    padding-top: 15px;
    padding-bottom: 15px;
    padding-left: 5px;
    padding-right: 5px;
}

.material-icons.md-18 { font-size: 18px; }
.material-icons.md-24 { font-size: 24px; }
.material-icons.md-36 { font-size: 36px; }
.material-icons.md-48 { font-size: 100px; }
.material-icons.md-light { color: rgba(255, 255, 255, 1); }
.material-icons.md-light.md-inactive { color: rgba(255, 255, 255, 0.3); }

.icons-center {
    vertical-align: middle;
    margin-right: 10px;
}

.inputBox {
    border: 1px solid #cacbcc;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1.5em;
    padding: 5px 5px 5px 5px;
    margin-top: 5px;
}

.inputBox:hover {
  
    border: 2px solid #448aff;
    border-radius: 5px;
    color: #29303b;
    font-size: 18px;
    height: auto;
    line-height: 1.5em;
    padding: 6px 6px 6px 6px;
    margin-top: 5px;
    background-color: #e0eff7;
      
}

.selected {
     background: #726a95;
}

.tableW {
    height: 40px;
}

.center {
    text-align: center;
}

tr:hover {
    background: #c8e6f5;
}

.headerCenter {
    text-align: center;
}


.modal {
     background-color: #29303b;
      border-radius: 5px;
}
.modalTitle {
    font-weight: normal;
    font-family: 'UberMove', 'Open Sans', 'Helvetica Neue', Helvetica, sans-serif !important;
    font-weight: 500;
    color: white;
    font-family: Poppins, sans-serif;
    margin-bottom: 0.5rem;
    line-height: 1.6;
}

.md-menu {
  padding: 0;
  padding: 0;

}

.custButton {
    margin: 10px;
    width: 120px;
    height: 40px;
    line-height:40px;
    font-size: 0.8rem;
   
}

.custMenuButton {
    
    width: 110px;
    height: 40px;
    line-height:45px;
    font-size: 0.9rem;
    align-self: center;
   
}

.custSearchBar{
      margin: 10px;
    width: 200px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
}


.custButtonRight {
    margin: 10px;
    width: 100px;
    height: 40px;
    float : right;
}



</style>



<script>
  /* eslint-disable no-plusplus */
  import { mapGetters } from 'vuex';
  import dateFormat from '../utils/dateFormat';
  import toGenerateExcelRequest, { downloadExcel } from "../utils/excel";
  import api from "../api";
  import parseXls from "../utils/parseXls";
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import AutocompleteCcicLocationSelect from "../components/AutocompleteCcicLocationSelect.vue";


    const getInitSearch = () => ({
    salesOffice: null,
    agreement: null,
    rateType: null,
    validOn: null,
    payer: null,
    departureCode: null,
    destinationCode: null,
    selected: false,
  });

  export default {

    data: () => ({
      searchRequest: getInitSearch(),
      active: false,
      items: [],
      dialog: {
        isShowing: false,
      },
      usersToSearch: [],
      modalMessage: "",  
      isWarning: false,
      sortStatus: true,
      filter:"",
      containerCopy: false,
    }),


    components: {
      AutocompleteCcicLocationSelect,
      callingApiCenter,
    },

    watch: {
      getGSTPrice(val) {
        this.updateItems(val);
      },
    },

    computed: {
    ...mapGetters([
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getPermission',
        'getUserProfile',
        'getRole',
        'getGSTPrice',
      ]),

      filteredRows(){
        return this.items.filter(row => {
          const term = this.filter.toUpperCase();
          return this.includeNull(row.agreement).includes(term) ||
                 this.includeNull(row.adesc).includes(term) ||
                 this.includeNull(row.rateType).includes(term)||
                 this.includeNull(row.rdesc).includes(term)||
                 this.includeNull(row.unit).includes(term)||
                 this.includeNull(row.amt).includes(term)||
                 this.includeNull(row.salesOffice).includes(term)||
                 this.includeNull(row.payer).includes(term)||
                 this.includeNull(row.orderType).includes(term)||
                 this.includeNull(row.commodity).includes(term)||
                 this.includeNull(row.ctnType).includes(term)||
                 this.includeNull(row.freeDay).includes(term)||
                 this.includeNull(row.currency).includes(term);
        })
      },

      getSelectedItems() {
        return _(this.items)
          .filter(it => it.selected);
      },

      getEditingItems() {
        return _(this.items)
          .filter(it => it.editing);
      },

      canEdit() {
        return this.getSelectedItems.length === 1 ;
      },




    },

    async mounted() {
      
       // this.$el.querySelector('#expand-button').click();
        const cachedSearchRequest = this.$store.state.gstPrice.searchRequest;
        //this.searchRequest.salesOffice = this.getUserProfile.driverGroup;
        this.searchRequest.salesOffice = this.getUserProfile.defaultSalesOffice;
        this.$el.querySelector('#searchTag').click();
        this.updateItems(this.getGSTPrice);

    },

     methods: {
        mouseOver: function(){
            this.active = true;
        },

        mouseLeave: function() {
          this.active = !this.active;
        },

        handleOfficeChanged(id) {
        this.searchRequest.salesOffice = id;
      },


      sortFunction(sortFiled){
                const sorted = _(this.items).sortBy(sortFiled);
                console.log(this.sortStatus)
                this.sortStatus = !this.sortStatus;
                if (this.sortStatus)
                {
                    this.items = sorted;
                }
                else
                {
                    this.items = sorted.reverse();
                }
          },




    //     hasBeenChanged(item) {
    //     const lhs = _(this.getGSTStage)
    //       .find(it => it.loadKeyWithStageNo === item.loadKeyWithStageNo);
    //     if (lhs) {
    //       return (moment(lhs.apptDate).format() !== moment(item.apptDate).format())
    //         || (lhs.appointment !== item.appointment)
    //         || (lhs.driverId !== item.driverId)
    //         || (lhs.truckId !== item.truckId)
    //         || (lhs.dispatcherInstruction !== item.dispatcherInstruction)
    //         || (lhs.costRelevant !== item.costRelevant)
    //         || (lhs.freightType !== item.freightType)
    //         || (lhs.stageStatus !== item.stageStatus)
    //         || (lhs.containerNo != item.containerNo)
    //         || (lhs.pickupLocationCode != item.pickupLocationCode)
    //         || (lhs.deliverLocationCode != item.deliverLocationCode);
    //     }
    //     return false;
    //   },

      toggleContainerCopy(element){
          this.containerCopy = true;
          setTimeout(() => {  this.containerCopy = false; }, 2000);
          var el = document.createElement('textarea');
          el.value = element;
          el.setAttribute('readonly', '');
          el.style = {position: 'absolute', left: '-9999px'};
          document.body.appendChild(el);
          el.select();
          document.execCommand('copy');
          document.body.removeChild(el);
      },

      updateItems(itemsSource) {
          var items = JSON.parse(JSON.stringify(itemsSource));
          items.forEach((it) => {
            it.backGroud = false;
            it.selected = false;
            it.editing = false;
          });
          this.items = items;
        },


      doSearch() {

        this.active = false;
        this.$store.dispatch('gstPrice', this.searchRequest);
       },


      doClear(){
        //   this.items = this.getGSTStage
        //   this.doSave()
      },

      handleScroll(e) {
        $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
              .offset().left),
          });
      },


      doNew() {
       
          this.$router.push({ 
            name: "PriceMaint" , 
            params: 
              {
              mode : 'CREATE'
            }})
      },


      doCopy() {
          const request = this.getSelectedItems[0]
          request.mode = 'COPY';
          // request.forEach((it) => {
          //   it.mode = 'COPY'
          // });

          this.$router.push({ 
            name: "PriceMaint" , 
            params: request })
      },

      doEdit(){
       const request = this.getSelectedItems[0]
      //  request.forEach((it) => {
      //       it.mode = 'CHANGE'
      //     });
          request.mode = 'CHANGE';
          this.$router.push({ 
            name: "PriceMaint" , 
            params: request})

      },



      uniqByLast(data, key){
        return [
          ...new Map(
            data.map(x => [key(x), x])
          ).values()
        ]
      },

      includeNull(field){
            return field==null ? '' : field;
        },
     },
    }
</script>